<div class="grid">
	<div class="col-12">
	  <div class="card" *ngIf="investment">
		<h5>Transacciones de {{investment.name}} - {{investment.user.name}} <small>{{investment.user.email}} </small></h5>
		<p-card [style]="{ width: '25rem', overflow: 'hidden',  margin: '20px auto' }">
			<h6 [style]="{ margin: '0px' }">
				Importe: <small>{{formatNumber(investment.amount)}} {{ getCurrencySymbol(investment.currency) }}</small>
			</h6>
			<h6 [style]="{ margin: '0px' }">
				Interés: <small>{{formatNumber(investment.interest)}} %</small>
			</h6>
			<h6 [style]="{ margin: '0px' }">
				Observación: <small>{{investment.description}}</small>
			</h6>
			<h6 [style]="{ margin: '0px' }">
				Rango: <small>{{investment.start_date | date:'dd/MM/yyyy'}} a {{investment.end_date | date:'dd/MM/yyyy'}}</small>
			</h6>
		</p-card>

		<p-table
		  #dt1
		  [value]="transactions"
		  dataKey="id"
		  [rows]="20"
		  [loading]="loading"
		  [rowHover]="true"
		  paginator="true"
		  [globalFilterFields]="['investment_name', 'transaction_date', 'amount', 'type', 'description']"
		  responsiveLayout="scroll"
		>
		  <ng-template pTemplate="caption">
			<div class="flex justify-content-between flex-column sm:flex-row">
			  <button
				pButton
				label="Limpiar"
				class="p-button-rounded mb-2"
				(click)="clear(dt1)"
			  ></button>
			  <span class="p-input-icon-left">
				<i class="pi pi-search"></i>
				<input
				  pInputText
				  type="text"
				  #filter
				  (input)="dt1.filterGlobal($event.target.value, 'contains')"
				  placeholder="Buscar"
				  class="w-full"
				/>
			  </span>
			  <div class="text-right">
				<button
				  pButton
				  tooltipPosition="top" 
				  pTooltip="Nueva transacción"
				  class="p-button-raised p-button-outlined m-1"
				  icon="pi pi-plus"
				  (click)="showDialog()"
				></button>
				<button
				  pButton
				  pRipple
				  label="Actualizar"
				  tooltipPosition="top" 
				  pTooltip="Actualizar listado de transacciones"
				  type="button"
				  icon="pi pi-refresh"
				  class="p-button-raised p-button-outlined m-1"
				  (click)="loadTransactions(); clear(dt1)"
				></button>
			  </div>
			</div>
		  </ng-template>
  
		  <ng-template pTemplate="header">
			<tr>
			<th class="text-center" pSortableColumn="transaction_date">
				<p-sortIcon field="transaction_date"></p-sortIcon> Fecha
			</th>
			  <th class="text-center">Importe</th>
			  <th class="text-center">Tipo</th>
			  <th class="text-center">Descripción</th>
			  <th></th>
			</tr>
		  </ng-template>
  
		  <ng-template pTemplate="body" let-transaction>
			<tr>
			  <td class="text-center">
				{{ transaction.transaction_date | date:'dd/MM/yyyy' }}
			  </td>
			  <td class="text-center">{{ formatNumber(transaction.amount) }} {{ getCurrencySymbol(investment?.currency) }}</td>
			  <td class="text-center fw-bold" [ngClass]="{'text-success':transaction.type === 'deposito', 'text-danger':transaction.type !== 'deposito'}">
				{{ transaction.type === 'deposito' ? 'Depósito' : 'Retirada' }}
			  </td>
			  <td class="text-center">{{ transaction.description }}</td>
			  <td class="text-center">
				<button
				  pButton
				  pRipple
				  type="button"
				  tooltipPosition="top" 
				  pTooltip="Editar transacción"
				  icon="pi pi-pencil"
				  class="p-button-raised p-button-outlined m-1"
				  (click)="showDialog(transaction)"
				></button>
				<button
				  pButton
				  pRipple
				  type="button"
				  tooltipPosition="top" 
				  pTooltip="Eliminar transacción"
				  icon="pi pi-trash"
				  class="p-button-danger p-button-raised p-button-outlined m-1"
				  (click)="deleteTransaction(transaction)"
				></button>
			  </td>
			</tr>
		  </ng-template>
  
		  <ng-template pTemplate="emptymessage">
			<tr>
			  <td colspan="8" class="text-center">Sin resultados</td>
			</tr>
		  </ng-template>
  
		  <ng-template pTemplate="loadingbody">
			<tr>
			  <td colspan="8">Cargando transacciones...</td>
			</tr>
		  </ng-template>
		</p-table>
	  </div>
	</div>
  </div>
  
  <!-- Diálogo para crear/editar transacción -->
  <p-dialog
	header="Datos de la transacción"
	[(visible)]="dialogTransaction"
	[modal]="true"
	[style]="{ width: '50vw' }"
	[draggable]="false"
	[resizable]="false"
	(onHide)="resetForm()"
  >
	<form [formGroup]="form">
	  <div class="grid p-fluid mt-3">
		<div class="field col-12 md:col-4">
		  <label>Importe {{ getCurrencySymbol(investment?.currency) }} *</label>
		  <input
			type="number"
			formControlName="amount"
			pInputText
			step="0.01"
			class="w-full"
		  />
		  <small
			class="p-error"
			*ngIf="form.get('amount').invalid && form.get('amount').touched"
			>Requerido y numérico</small
		  >
		</div>
		<div class="field col-12 md:col-4">
		  <label>Fecha de transacción *</label>
		  <p-calendar
		    appendTo="body"
			formControlName="transaction_date"
			dateFormat="dd-mm-yy"
		  ></p-calendar>
		  <small
			class="p-error"
			*ngIf="
			  form.get('transaction_date').invalid &&
			  form.get('transaction_date').touched
			"
			>Requerido</small
		  >
		</div>
		<div class="field col-12 md:col-4">
		  <label>Tipo *</label>
		  <p-dropdown
		    [filter]="true"
			formControlName="type"
			[options]="typeOptions"
			placeholder="Seleccione tipo"
		  ></p-dropdown>
		  <small
			class="p-error"
			*ngIf="form.get('type').invalid && form.get('type').touched"
			>Requerido</small
		  >
		</div>
	  </div>
	  <div class="grid p-fluid mt-3">
		<div class="field col-12">
		  <label>Descripción</label>
		  <textarea
			formControlName="description"
			pInputTextarea
			rows="3"
			class="w-full"
		  ></textarea>
		</div>
	  </div>
	  <div class="flex justify-content-end mt-3">
		<p-button
		  styleClass="p-button-rounded"
		  [label]="mode === 'register' ? 'Guardar' : 'Actualizar'"
		  (click)="mode === 'register' ? registerTransaction() : updateTransaction()"
		  [loading]="loading"
		></p-button>
	  </div>
	</form>
  </p-dialog>
  